import myRenderer from './myRenderer';
import textRenderer from './textRenderer';
import pathMap from './pathMap';

export default {
  __init__: [ 'myRenderer' ],
  myRenderer: [ 'type', myRenderer ],
  textRenderer: [ 'type', textRenderer ],
  pathMap: [ 'type', pathMap ]
};